<div class="modal-backdrop" *ngIf="open" (click)="cancelled.emit()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <h3 class="modal-title">{{ title }}</h3>
    <p class="modal-message" *ngIf="message">{{ message }}</p>

    <div class="modal-actions">
      <app-button variant="secondary" (clicked)="cancelled.emit()" [disabled]="busy">{{ cancelLabel }}</app-button>
      <app-button [variant]="confirmVariant" (clicked)="confirmed.emit()" [loading]="busy">{{ confirmLabel }}</app-button>
    </div>
  </div>
</div>
